import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga4";

export function GoogleAnalytics() {
  const location = useLocation();
  const lastTracked = useRef(null);

  useEffect(() => {
    const page = `${location.pathname}${location.search}`;
    if (lastTracked.current === page) return;
    lastTracked.current = page;

    ReactGA.send({
      hitType: "pageview",
      page,
      title: document.title,
    });
  }, [location.pathname, location.search]);

  return null;
}
